export enum EventStatus {
  ARCHIVE = "archive",
  ACTIVE = "active",
  INACTIVE = "inactive",
}

export interface Event {
  event_id: number;
  org_id: number;
  name: string;
  description?: string;
  status: EventStatus;
  start_date?: string; // ISO string
  end_date?: string;   // ISO string
  is_queue_enabled?: boolean;
  created_at?: string;
  updated_at?: string;
}

export interface EventResponseList {
  data: Event[];
  total_count: number;
  filter_count: number;
}

export interface EventTable {
  data: Event[];
  links?: any;
  meta?: any;
}
